import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import siteList from './sitelist.json'
import siteInfoSample from './siteInfo.json'
import regionInverter from './regionInverter.json'
import regionsInverter from './regionsInverter.json'
import solraUnitedWork from './unitedSiteInfo.json'
import solraDayWork from './solraDayWork.json'
import solraMonthWork from './solraMonthWork.json'
import solraYearWork from './solraYearWork.json'
import solraPrice from './solraPrice.json'
import solraMonthAvgPrice from './smpMonthAvgPrice.json'
import siteWorkRecord from './siteWorkRecord.json'
import siteBrokenRecord from './siteBrokenRecord.json'

export function getSiteYesterday(site) {
  return request({
    url: `/monitoring/site/${site}/yesterday`,
    method: 'GET',
    meta: { useAuth: true, useErrorMessage: false }
  })
}

export function getSiteList(params) {
  return request({
    url: '/site/getList',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })

  // restful api를 사용하지 않을 경우
  /*
  return new Promise(function(resolve, reject) {
    resolve(siteList);
  });
  */
}

export function getAvgRun(params) {
  return request({
    url: '/site/getAvgRun',
    data: params,
    method: 'POST'
  })
}

export function getTotalSiteCount() {
  return request({
    url: '/master/site/getTotalSiteCount',
    method: 'POST'
  })
}

export function getSiteInfo(params) {
  return request({
    url: '/site/getSiteInfo' + params,
    method: 'get',
    meta: { useAuth: true }
  })
}

export function getSiteSearchList(params) {
  return request({
    url: '/site/getSiteSearchList' + params,
    method: 'get'
  })
}

export function getRegionsInverter(params) {
  if (isUseAPI()) {
    return request({
      url: '/site/getRegionsInverter',
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(regionsInverter)
  })
}

export function getRegionInverter(params) {
  if (isUseAPI()) {
    return request({
      url: '/site/getRegionInverter' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(regionInverter)
  })
}

export function getSolraUnitedWork(params) {
  return request({
    url: '/site/getSolraUnitedWork' + params,
    method: 'get'
  })
}

export function getSolraUnitedInverterWork(params) {
  return request({
    url: '/site/getSolraUnitedInverterWork' + params,
    method: 'get',
    meta: { useErrorMessage: false }
  })
}

export function getSolraDayWork(params) {
  return request({
    url: '/site/getSolraDayWork' + params,
    method: 'get'
  })
}

export function getSolraInverterDayWork(params) {
  return request({
    url: '/site/getSolraInverterDayWork' + params,
    method: 'get'
  })
}

export function getSolraMonthWork(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getSolraMonthWork' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraMonthWork)
  })
}

export function getSolraInverterMonthWork(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getSolraInverterMonthWork' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraMonthWork)
  })
}

export function getSolraYearWork(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getSolraYearWork' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraYearWork)
  })
}

export function getSolraInverterYearWork(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getSolraInverterYearWork' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraYearWork)
  })
}

export function getSolraPrice(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getSolraPrice' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraPrice)
  })
}

export function getSMPMonthAvgPrice(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/smp/getSMPMonthAvgPrice' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(solraMonthAvgPrice)
  })
}

export function getWorkRecord(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getWorkRecord' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(siteWorkRecord)
  })
}

export function getBrokenRecord(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getBrokenRecord' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(siteBrokenRecord)
  })
}

export function getUnityWorkRecord(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/site/getUnityWorkRecord' + params,
      method: 'get'
    })
  }
  console.log('aaaasdasd')
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(menuMockupData)
  })
}
